import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Medal, Plus, User } from 'lucide-react';
import MobileMoreDrawer from './MobileMoreDrawer';

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Home',   icon: LayoutDashboard, exact: true },
  { to: '/dashboard/badges', label: 'Badges', icon: Medal },
  { to: '/dashboard/projects/new', label: 'New', icon: Plus, isNew: true },
];

export default function BottomNav() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <nav className="bottom-nav" role="navigation" aria-label="Main navigation" data-testid="bottom-nav">
        {NAV_ITEMS.map(({ to, label, icon: Icon, exact, isNew }) => (
          <NavLink
            key={to}
            to={to}
            end={exact}
            className={({ isActive }) => `bn-item${isNew ? ' bn-item-new' : ''}${isActive ? ' active' : ''}`}
            data-testid={`bnav-${label.toLowerCase()}`}
            aria-label={label}
          >
            <Icon size={isNew ? 22 : 20} strokeWidth={isNew ? 2.5 : 1.6} />
            {!isNew && <span>{label}</span>}
          </NavLink>
        ))}

        {/* Profile / More — opens slide-up drawer */}
        <button
          className="bn-item"
          data-testid="bnav-profile"
          aria-label="Menu"
          onClick={() => setDrawerOpen(true)}
        >
          <User size={20} strokeWidth={1.6} />
          <span>Profile</span>
        </button>
      </nav>

      <MobileMoreDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
}
